import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.map.js";
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, unref as _unref, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue";
const _hoisted_1 = {
  class: "system-config form"
};
const _hoisted_2 = {
  class: "container"
};
const _hoisted_3 = {
  class: "label-title"
};
const _hoisted_4 = {
  class: "d-flex justify-between w-100"
};
const _hoisted_5 = {
  class: "label-title"
};
const _hoisted_6 = {
  class: "label-title"
};
const _hoisted_7 = {
  class: "label-title"
};
const _hoisted_8 = {
  class: "label-title"
};
const _hoisted_9 = {
  class: "tip-input-line"
};
const _hoisted_10 = {
  class: "label-title"
};
const _hoisted_11 = {
  class: "label-title"
};
const _hoisted_12 = {
  class: "label-title"
};
const _hoisted_13 = {
  class: "label-title"
};
const _hoisted_14 = {
  class: "label-title"
};
const _hoisted_15 = {
  class: "label-title"
};
const _hoisted_16 = {
  class: "label-title"
};
const _hoisted_17 = {
  class: "label-title"
};
const _hoisted_18 = {
  style: {
    "padding": "10px"
  }
};
const _hoisted_19 = {
  style: {
    "padding-top": "10px",
    "margin-left": "150px"
  }
};
const _hoisted_20 = {
  style: {
    "padding-top": "10px",
    "margin-left": "150px"
  }
};
const _hoisted_21 = {
  class: "container"
};
const _hoisted_22 = {
  class: "container"
};
const _hoisted_23 = {
  class: "mt-3"
};
import { onMounted, reactive, ref } from "vue";
import { httpGet, httpPost } from "@/utils/http";
import Compressor from "compressorjs";
import { ElMessage, ElMessageBox } from "element-plus";
import { CloseBold, InfoFilled, Select, UploadFilled } from "@element-plus/icons-vue";
import MdEditor from "md-editor-v3";
import "md-editor-v3/lib/style.css";
import Menu from "@/views/admin/Menu.vue";
import { copyObj, dateFormat } from "@/utils/libs";
import ItemsInput from "@/components/ui/ItemsInput.vue";
import { useSharedStore } from "@/store/sharedata";
export default {
  __name: 'SysConfig',
  setup(__props) {
    const activeName = ref("basic");
    const system = ref({
      models: []
    });
    const configBak = ref({});
    const loading = ref(true);
    const systemFormRef = ref(null);
    const models = ref([]);
    const notice = ref("");
    const license = ref({
      is_active: false
    });
    const menus = ref([]);
    const mjModels = ref([{
      name: "慢速（Relax）",
      value: "relax"
    }, {
      name: "快速（Fast）",
      value: "fast"
    }, {
      name: "急速（Turbo）",
      value: "turbo"
    }]);
    const store = useSharedStore();
    onMounted(() => {
      // 加载系统配置
      httpGet("/admin/config/get?key=system").then(res => {
        system.value = res.data;
        configBak.value = copyObj(system.value);
      }).catch(e => {
        ElMessage.error("加载系统配置失败: " + e.message);
      });
      // 加载聊天配置
      httpGet("/admin/config/get?key=notice").then(res => {
        notice.value = res.data["content"];
      }).catch(e => {
        ElMessage.error("公告信息失败: " + e.message);
      });
      httpGet("/admin/model/list").then(res => {
        models.value = res.data;
        loading.value = false;
      }).catch(e => {
        ElMessage.error("获取模型失败：" + e.message);
      });
      httpGet("/admin/menu/list").then(res => {
        menus.value = res.data;
      }).catch(e => {
        ElMessage.error("获取模型失败：" + e.message);
      });
      fetchLicense();
    });
    const fetchLicense = () => {
      httpGet("/admin/config/license").then(res => {
        license.value = res.data;
      }).catch(e => {
        ElMessage.error("获取 License 失败：" + e.message);
      });
    };
    const rules = reactive({
      title: [{
        required: true,
        message: "请输入网站标题",
        trigger: "blur"
      }],
      admin_title: [{
        required: true,
        message: "请输入控制台标题",
        trigger: "blur"
      }],
      init_chat_calls: [{
        required: true,
        message: "请输入赠送对话次数",
        trigger: "blur"
      }],
      user_img_calls: [{
        required: true,
        message: "请输入赠送绘图次数",
        trigger: "blur"
      }]
    });
    const save = function (key) {
      if (key === "system") {
        systemFormRef.value.validate(valid => {
          if (valid) {
            httpPost("/admin/config/update", {
              key: key,
              config: system.value,
              config_bak: configBak.value
            }).then(() => {
              ElMessage.success("操作成功！");
            }).catch(e => {
              ElMessage.error("操作失败：" + e.message);
            });
          }
        });
      } else if (key === "notice") {
        httpPost("/admin/config/update", {
          key: key,
          config: {
            content: notice.value,
            updated: true
          }
        }).then(() => {
          ElMessage.success("操作成功！");
        }).catch(e => {
          ElMessage.error("操作失败：" + e.message);
        });
      }
    };

    // 激活授权
    const licenseKey = ref("");
    const active = () => {
      if (licenseKey.value === "") {
        return ElMessage.error("请输入授权码");
      }
      httpPost("/admin/config/active", {
        license: licenseKey.value
      }).then(res => {
        ElMessage.success("授权成功，机器编码为：" + res.data);
        fetchLicense();
      }).catch(e => {
        ElMessage.error(e.message);
      });
    };
    const configKey = ref("");
    const beforeUpload = key => {
      configKey.value = key;
    };

    // 图片上传
    const uploadImg = file => {
      // 压缩图片并上传
      new Compressor(file.file, {
        quality: 0.6,
        success(result) {
          const formData = new FormData();
          formData.append("file", result, result.name);
          // 执行上传操作
          httpPost("/admin/upload", formData).then(res => {
            system.value[configKey.value] = res.data.url;
            ElMessage.success("上传成功");
          }).catch(e => {
            ElMessage.error("上传失败:" + e.message);
          });
        },
        error(e) {
          ElMessage.error("上传失败:" + e.message);
        }
      });
    };

    // 编辑期文件上传处理
    const onUploadImg = (files, callback) => {
      Promise.all(files.map(file => {
        return new Promise((rev, rej) => {
          const formData = new FormData();
          formData.append("file", file, file.name);
          // 执行上传操作
          httpPost("/admin/upload", formData).then(res => rev(res)).catch(error => rej(error));
        });
      })).then(res => {
        ElMessage.success({
          message: "上传成功",
          duration: 500
        });
        callback(res.map(item => item.data.url));
      }).catch(e => {
        ElMessage.error("图片上传失败:" + e.message);
      });
    };
    const fixData = () => {
      ElMessageBox.confirm("在修复数据前，请先备份好数据库，以免数据丢失！是否继续操作?", "警告", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        loading.value = true;
        httpGet("/admin/config/fixData").then(() => {
          ElMessage.success("数据修复成功");
          loading.value = false;
        }).catch(e => {
          loading.value = false;
          ElMessage.error("数据修复失败：" + e.message);
        });
      });
    };
    return (_ctx, _cache) => {
      const _component_el_input = _resolveComponent("el-input");
      const _component_el_form_item = _resolveComponent("el-form-item");
      const _component_el_icon = _resolveComponent("el-icon");
      const _component_el_upload = _resolveComponent("el-upload");
      const _component_el_tooltip = _resolveComponent("el-tooltip");
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_option = _resolveComponent("el-option");
      const _component_el_select = _resolveComponent("el-select");
      const _component_el_switch = _resolveComponent("el-switch");
      const _component_el_checkbox = _resolveComponent("el-checkbox");
      const _component_el_checkbox_group = _resolveComponent("el-checkbox-group");
      const _component_el_input_number = _resolveComponent("el-input-number");
      const _component_el_tab_pane = _resolveComponent("el-tab-pane");
      const _component_el_tabs = _resolveComponent("el-tabs");
      const _component_el_form = _resolveComponent("el-form");
      const _component_el_descriptions_item = _resolveComponent("el-descriptions-item");
      const _component_el_descriptions = _resolveComponent("el-descriptions");
      const _directive_loading = _resolveDirective("loading");
      return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_tabs, {
        modelValue: activeName.value,
        "onUpdate:modelValue": _cache[41] || (_cache[41] = $event => activeName.value = $event),
        class: "sys-tabs"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_tab_pane, {
          label: "系统配置",
          name: "basic"
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_2, [_createVNode(_component_el_form, {
            model: system.value,
            "label-width": "150px",
            "label-position": "right",
            ref_key: "systemFormRef",
            ref: systemFormRef,
            rules: rules
          }, {
            default: _withCtx(() => [_createVNode(_component_el_tabs, {
              type: "border-card"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_tab_pane, {
                label: "基础配置"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_form_item, {
                  label: "网站标题",
                  prop: "title"
                }, {
                  default: _withCtx(() => [_createVNode(_component_el_input, {
                    modelValue: system.value['title'],
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => system.value['title'] = $event)
                  }, null, 8, ["modelValue"])]),
                  _: 1
                }), _createVNode(_component_el_form_item, {
                  label: "控制台标题",
                  prop: "admin_title"
                }, {
                  default: _withCtx(() => [_createVNode(_component_el_input, {
                    modelValue: system.value['admin_title'],
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => system.value['admin_title'] = $event)
                  }, null, 8, ["modelValue"])]),
                  _: 1
                }), _createVNode(_component_el_form_item, {
                  label: "网站Slogan",
                  prop: "slogan"
                }, {
                  default: _withCtx(() => [_createVNode(_component_el_input, {
                    modelValue: system.value['slogan'],
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => system.value['slogan'] = $event)
                  }, null, 8, ["modelValue"])]),
                  _: 1
                }), _createVNode(_component_el_form_item, {
                  label: "网站 LOGO",
                  prop: "logo"
                }, {
                  default: _withCtx(() => [_createVNode(_component_el_input, {
                    modelValue: system.value['logo'],
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => system.value['logo'] = $event),
                    placeholder: "网站LOGO图片"
                  }, {
                    append: _withCtx(() => [_createVNode(_component_el_upload, {
                      "auto-upload": true,
                      "show-file-list": false,
                      onClick: _cache[3] || (_cache[3] = $event => beforeUpload('logo')),
                      "http-request": uploadImg
                    }, {
                      default: _withCtx(() => [_createVNode(_component_el_icon, {
                        class: "uploader-icon"
                      }, {
                        default: _withCtx(() => [_createVNode(_unref(UploadFilled))]),
                        _: 1
                      })]),
                      _: 1
                    })]),
                    _: 1
                  }, 8, ["modelValue"])]),
                  _: 1
                }), _createVNode(_component_el_form_item, null, {
                  label: _withCtx(() => [_createElementVNode("div", _hoisted_3, [_cache[42] || (_cache[42] = _createTextVNode(" 首页背景图 ")), _createVNode(_component_el_tooltip, {
                    effect: "dark",
                    content: "网站首页背景图片",
                    "raw-content": "",
                    placement: "right"
                  }, {
                    default: _withCtx(() => [_createVNode(_component_el_icon, null, {
                      default: _withCtx(() => [_createVNode(_unref(InfoFilled))]),
                      _: 1
                    })]),
                    _: 1
                  })])]),
                  default: _withCtx(() => [_createElementVNode("div", _hoisted_4, [_createVNode(_component_el_input, {
                    modelValue: system.value['index_bg_url'],
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => system.value['index_bg_url'] = $event),
                    placeholder: "网站首页背景图片"
                  }, {
                    append: _withCtx(() => [_createVNode(_component_el_upload, {
                      "auto-upload": true,
                      "show-file-list": false,
                      onClick: _cache[5] || (_cache[5] = $event => beforeUpload('index_bg_url')),
                      "http-request": uploadImg
                    }, {
                      default: _withCtx(() => [_createVNode(_component_el_icon, {
                        class: "uploader-icon"
                      }, {
                        default: _withCtx(() => [_createVNode(_unref(UploadFilled))]),
                        _: 1
                      })]),
                      _: 1
                    })]),
                    _: 1
                  }, 8, ["modelValue"]), _createVNode(_component_el_button, {
                    class: "ml-1",
                    type: "primary",
                    onClick: _cache[7] || (_cache[7] = $event => system.value.index_bg_url = 'https://api.dujin.org/bing/1920.php')
                  }, {
                    default: _withCtx(() => _cache[43] || (_cache[43] = [_createTextVNode("使用动态背景")])),
                    _: 1
                  }), _createVNode(_component_el_button, {
                    class: "ml-1",
                    onClick: _cache[8] || (_cache[8] = $event => system.value.index_bg_url = 'color')
                  }, {
                    default: _withCtx(() => _cache[44] || (_cache[44] = [_createTextVNode("使用纯色背景")])),
                    _: 1
                  })])]),
                  _: 1
                }), _createVNode(_component_el_form_item, null, {
                  label: _withCtx(() => [_createElementVNode("div", _hoisted_5, [_cache[45] || (_cache[45] = _createTextVNode(" 首页导航菜单 ")), _createVNode(_component_el_tooltip, {
                    effect: "dark",
                    content: "被选中的菜单将会在首页导航栏显示",
                    "raw-content": "",
                    placement: "right"
                  }, {
                    default: _withCtx(() => [_createVNode(_component_el_icon, null, {
                      default: _withCtx(() => [_createVNode(_unref(InfoFilled))]),
                      _: 1
                    })]),
                    _: 1
                  })])]),
                  default: _withCtx(() => [_createVNode(_component_el_select, {
                    modelValue: system.value['index_navs'],
                    "onUpdate:modelValue": _cache[9] || (_cache[9] = $event => system.value['index_navs'] = $event),
                    multiple: "",
                    filterable: true,
                    placeholder: "请选择菜单，多选",
                    style: {
                      "width": "100%"
                    }
                  }, {
                    default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(menus.value, item => {
                      return _openBlock(), _createBlock(_component_el_option, {
                        key: item.id,
                        label: item.name,
                        value: item.id
                      }, null, 8, ["label", "value"]);
                    }), 128))]),
                    _: 1
                  }, 8, ["modelValue"])]),
                  _: 1
                }), _createVNode(_component_el_form_item, {
                  label: "版权信息",
                  prop: "copyright"
                }, {
                  default: _withCtx(() => [_createVNode(_component_el_input, {
                    modelValue: system.value['copyright'],
                    "onUpdate:modelValue": _cache[10] || (_cache[10] = $event => system.value['copyright'] = $event),
                    placeholder: "更改此选项需要获取 License 授权"
                  }, null, 8, ["modelValue"])]),
                  _: 1
                }), _createVNode(_component_el_form_item, null, {
                  label: _withCtx(() => [_createElementVNode("div", _hoisted_6, [_cache[46] || (_cache[46] = _createTextVNode(" 开放注册 ")), _createVNode(_component_el_tooltip, {
                    effect: "dark",
                    content: "关闭注册之后只能通过管理后台添加用户",
                    "raw-content": "",
                    placement: "right"
                  }, {
                    default: _withCtx(() => [_createVNode(_component_el_icon, null, {
                      default: _withCtx(() => [_createVNode(_unref(InfoFilled))]),
                      _: 1
                    })]),
                    _: 1
                  })])]),
                  default: _withCtx(() => [_createVNode(_component_el_switch, {
                    modelValue: system.value['enabled_register'],
                    "onUpdate:modelValue": _cache[11] || (_cache[11] = $event => system.value['enabled_register'] = $event)
                  }, null, 8, ["modelValue"])]),
                  _: 1
                }), _createVNode(_component_el_form_item, null, {
                  label: _withCtx(() => [_createElementVNode("div", _hoisted_7, [_cache[47] || (_cache[47] = _createTextVNode(" 启用验证码 ")), _createVNode(_component_el_tooltip, {
                    effect: "dark",
                    content: "启用验证码之后，注册登录都会加载行为验证码，增加安全性。此功能需要购买验证码服务才会生效。",
                    "raw-content": "",
                    placement: "right"
                  }, {
                    default: _withCtx(() => [_createVNode(_component_el_icon, null, {
                      default: _withCtx(() => [_createVNode(_unref(InfoFilled))]),
                      _: 1
                    })]),
                    _: 1
                  })])]),
                  default: _withCtx(() => [_createVNode(_component_el_switch, {
                    modelValue: system.value['enabled_verify'],
                    "onUpdate:modelValue": _cache[12] || (_cache[12] = $event => system.value['enabled_verify'] = $event)
                  }, null, 8, ["modelValue"])]),
                  _: 1
                }), _createVNode(_component_el_form_item, {
                  label: "注册方式",
                  prop: "register_ways"
                }, {
                  default: _withCtx(() => [_createVNode(_component_el_checkbox_group, {
                    modelValue: system.value['register_ways'],
                    "onUpdate:modelValue": _cache[13] || (_cache[13] = $event => system.value['register_ways'] = $event)
                  }, {
                    default: _withCtx(() => [_createVNode(_component_el_checkbox, {
                      value: "mobile"
                    }, {
                      default: _withCtx(() => _cache[48] || (_cache[48] = [_createTextVNode("手机注册")])),
                      _: 1
                    }), _createVNode(_component_el_checkbox, {
                      value: "email"
                    }, {
                      default: _withCtx(() => _cache[49] || (_cache[49] = [_createTextVNode("邮箱注册")])),
                      _: 1
                    }), _createVNode(_component_el_checkbox, {
                      value: "username"
                    }, {
                      default: _withCtx(() => _cache[50] || (_cache[50] = [_createTextVNode("用户名注册")])),
                      _: 1
                    })]),
                    _: 1
                  }, 8, ["modelValue"])]),
                  _: 1
                }), _createVNode(_component_el_form_item, {
                  label: "邮件域名白名单",
                  prop: "register_ways"
                }, {
                  default: _withCtx(() => [_createVNode(ItemsInput, {
                    value: system.value['email_white_list'],
                    "onUpdate:value": _cache[14] || (_cache[14] = $event => system.value['email_white_list'] = $event)
                  }, null, 8, ["value"])]),
                  _: 1
                }), _createVNode(_component_el_form_item, {
                  label: "微信客服二维码",
                  prop: "wechat_card_url"
                }, {
                  default: _withCtx(() => [_createVNode(_component_el_input, {
                    modelValue: system.value['wechat_card_url'],
                    "onUpdate:modelValue": _cache[16] || (_cache[16] = $event => system.value['wechat_card_url'] = $event),
                    placeholder: "微信客服二维码"
                  }, {
                    append: _withCtx(() => [_createVNode(_component_el_upload, {
                      "auto-upload": true,
                      "show-file-list": false,
                      onClick: _cache[15] || (_cache[15] = $event => beforeUpload('wechat_card_url')),
                      "http-request": uploadImg
                    }, {
                      default: _withCtx(() => [_createVNode(_component_el_icon, {
                        class: "uploader-icon"
                      }, {
                        default: _withCtx(() => [_createVNode(_unref(UploadFilled))]),
                        _: 1
                      })]),
                      _: 1
                    })]),
                    _: 1
                  }, 8, ["modelValue"])]),
                  _: 1
                }), _createVNode(_component_el_form_item, null, {
                  label: _withCtx(() => [_createElementVNode("div", _hoisted_8, [_cache[51] || (_cache[51] = _createTextVNode(" 默认翻译模型 ")), _createVNode(_component_el_tooltip, {
                    effect: "dark",
                    content: "选择一个默认模型来翻译提示词",
                    "raw-content": "",
                    placement: "right"
                  }, {
                    default: _withCtx(() => [_createVNode(_component_el_icon, null, {
                      default: _withCtx(() => [_createVNode(_unref(InfoFilled))]),
                      _: 1
                    })]),
                    _: 1
                  })])]),
                  default: _withCtx(() => [_createVNode(_component_el_select, {
                    modelValue: system.value['translate_model_id'],
                    "onUpdate:modelValue": _cache[17] || (_cache[17] = $event => system.value['translate_model_id'] = $event),
                    modelModifiers: {
                      number: true
                    },
                    filterable: true,
                    placeholder: "选择一个默认模型来翻译提示词",
                    style: {
                      "width": "100%"
                    }
                  }, {
                    default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(models.value, item => {
                      return _openBlock(), _createBlock(_component_el_option, {
                        key: item.id,
                        label: item.name,
                        value: item.id
                      }, null, 8, ["label", "value"]);
                    }), 128))]),
                    _: 1
                  }, 8, ["modelValue"])]),
                  _: 1
                }), _createVNode(_component_el_form_item, {
                  label: "开启聊天上下文"
                }, {
                  default: _withCtx(() => [_createVNode(_component_el_switch, {
                    modelValue: system.value['enable_context'],
                    "onUpdate:modelValue": _cache[18] || (_cache[18] = $event => system.value['enable_context'] = $event)
                  }, null, 8, ["modelValue"])]),
                  _: 1
                }), _createVNode(_component_el_form_item, {
                  label: "会话上下文深度"
                }, {
                  default: _withCtx(() => [_createElementVNode("div", _hoisted_9, [_createVNode(_component_el_input_number, {
                    modelValue: system.value['context_deep'],
                    "onUpdate:modelValue": _cache[19] || (_cache[19] = $event => system.value['context_deep'] = $event),
                    min: 0,
                    max: 10
                  }, null, 8, ["modelValue"]), _cache[52] || (_cache[52] = _createElementVNode("div", {
                    class: "tip"
                  }, " 会话上下文深度：在老会话中继续会话，默认加载多少条聊天记录作为上下文。如果设置为 0 则不加载聊天记录，仅仅使用当前角色的上下文。该配置参数必须设置需要为偶数。 ", -1))])]),
                  _: 1
                }), _createVNode(_component_el_form_item, null, {
                  label: _withCtx(() => [_createElementVNode("div", _hoisted_10, [_cache[53] || (_cache[53] = _createTextVNode(" SD反向提示词 ")), _createVNode(_component_el_tooltip, {
                    effect: "dark",
                    content: "Stable-Diffusion 绘画默认反向提示词",
                    "raw-content": "",
                    placement: "right"
                  }, {
                    default: _withCtx(() => [_createVNode(_component_el_icon, null, {
                      default: _withCtx(() => [_createVNode(_unref(InfoFilled))]),
                      _: 1
                    })]),
                    _: 1
                  })])]),
                  default: _withCtx(() => [_createVNode(_component_el_input, {
                    type: "textarea",
                    rows: 2,
                    modelValue: system.value['sd_neg_prompt'],
                    "onUpdate:modelValue": _cache[20] || (_cache[20] = $event => system.value['sd_neg_prompt'] = $event),
                    placeholder: ""
                  }, null, 8, ["modelValue"])]),
                  _: 1
                }), _createVNode(_component_el_form_item, {
                  label: "会员充值说明",
                  prop: "order_pay_timeout"
                }, {
                  label: _withCtx(() => [_createElementVNode("div", _hoisted_11, [_cache[54] || (_cache[54] = _createTextVNode(" 会员充值说明 ")), _createVNode(_component_el_tooltip, {
                    effect: "dark",
                    content: "会员充值页面的充值说明文字",
                    "raw-content": "",
                    placement: "right"
                  }, {
                    default: _withCtx(() => [_createVNode(_component_el_icon, null, {
                      default: _withCtx(() => [_createVNode(_unref(InfoFilled))]),
                      _: 1
                    })]),
                    _: 1
                  })])]),
                  default: _withCtx(() => [_createVNode(_component_el_input, {
                    type: "textarea",
                    rows: 2,
                    modelValue: system.value['vip_info_text'],
                    "onUpdate:modelValue": _cache[21] || (_cache[21] = $event => system.value['vip_info_text'] = $event),
                    placeholder: ""
                  }, null, 8, ["modelValue"])]),
                  _: 1
                }), _createVNode(_component_el_form_item, {
                  label: "MJ默认API模式",
                  prop: "mj_mode"
                }, {
                  default: _withCtx(() => [_createVNode(_component_el_select, {
                    modelValue: system.value['mj_mode'],
                    "onUpdate:modelValue": _cache[22] || (_cache[22] = $event => system.value['mj_mode'] = $event),
                    placeholder: "请选择模式"
                  }, {
                    default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(mjModels.value, item => {
                      return _openBlock(), _createBlock(_component_el_option, {
                        value: item.value,
                        label: item.name,
                        key: item.value
                      }, {
                        default: _withCtx(() => [_createTextVNode(_toDisplayString(item.name), 1)]),
                        _: 2
                      }, 1032, ["value", "label"]);
                    }), 128))]),
                    _: 1
                  }, 8, ["modelValue"])]),
                  _: 1
                })]),
                _: 1
              }), _createVNode(_component_el_tab_pane, {
                label: "算力配置"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_form_item, {
                  label: "注册赠送算力",
                  prop: "init_power"
                }, {
                  default: _withCtx(() => [_createVNode(_component_el_input, {
                    modelValue: system.value['init_power'],
                    "onUpdate:modelValue": _cache[23] || (_cache[23] = $event => system.value['init_power'] = $event),
                    modelModifiers: {
                      number: true
                    },
                    placeholder: "新用户注册赠送算力"
                  }, null, 8, ["modelValue"])]),
                  _: 1
                }), _createVNode(_component_el_form_item, {
                  label: "邀请赠送算力",
                  prop: "invite_power"
                }, {
                  default: _withCtx(() => [_createVNode(_component_el_input, {
                    modelValue: system.value['invite_power'],
                    "onUpdate:modelValue": _cache[24] || (_cache[24] = $event => system.value['invite_power'] = $event),
                    modelModifiers: {
                      number: true
                    },
                    placeholder: "邀请新用户注册赠送算力"
                  }, null, 8, ["modelValue"])]),
                  _: 1
                }), _createVNode(_component_el_form_item, {
                  label: "VIP每月赠送算力",
                  prop: "vip_month_power"
                }, {
                  default: _withCtx(() => [_createVNode(_component_el_input, {
                    modelValue: system.value['vip_month_power'],
                    "onUpdate:modelValue": _cache[25] || (_cache[25] = $event => system.value['vip_month_power'] = $event),
                    modelModifiers: {
                      number: true
                    },
                    placeholder: "VIP用户每月赠送算力"
                  }, null, 8, ["modelValue"])]),
                  _: 1
                }), _createVNode(_component_el_form_item, null, {
                  label: _withCtx(() => [_createElementVNode("div", _hoisted_12, [_cache[55] || (_cache[55] = _createTextVNode(" 签到赠送算力 ")), _createVNode(_component_el_tooltip, {
                    effect: "dark",
                    content: "每日签到赠送算力",
                    "raw-content": "",
                    placement: "right"
                  }, {
                    default: _withCtx(() => [_createVNode(_component_el_icon, null, {
                      default: _withCtx(() => [_createVNode(_unref(InfoFilled))]),
                      _: 1
                    })]),
                    _: 1
                  })])]),
                  default: _withCtx(() => [_createVNode(_component_el_input, {
                    modelValue: system.value['daily_power'],
                    "onUpdate:modelValue": _cache[26] || (_cache[26] = $event => system.value['daily_power'] = $event),
                    modelModifiers: {
                      number: true
                    },
                    placeholder: "默认值0"
                  }, null, 8, ["modelValue"])]),
                  _: 1
                }), _createVNode(_component_el_form_item, null, {
                  label: _withCtx(() => [_createElementVNode("div", _hoisted_13, [_cache[56] || (_cache[56] = _createTextVNode(" MJ绘图算力 ")), _createVNode(_component_el_tooltip, {
                    effect: "dark",
                    content: "使用MidJourney画一张图消耗算力",
                    "raw-content": "",
                    placement: "right"
                  }, {
                    default: _withCtx(() => [_createVNode(_component_el_icon, null, {
                      default: _withCtx(() => [_createVNode(_unref(InfoFilled))]),
                      _: 1
                    })]),
                    _: 1
                  })])]),
                  default: _withCtx(() => [_createVNode(_component_el_input, {
                    modelValue: system.value['mj_power'],
                    "onUpdate:modelValue": _cache[27] || (_cache[27] = $event => system.value['mj_power'] = $event),
                    modelModifiers: {
                      number: true
                    },
                    placeholder: ""
                  }, null, 8, ["modelValue"])]),
                  _: 1
                }), _createVNode(_component_el_form_item, null, {
                  label: _withCtx(() => [_createElementVNode("div", _hoisted_14, [_cache[57] || (_cache[57] = _createTextVNode(" MJ操作算力 ")), _createVNode(_component_el_tooltip, {
                    effect: "dark",
                    content: "放大，变换，重绘操作一次消耗的算力",
                    "raw-content": "",
                    placement: "right"
                  }, {
                    default: _withCtx(() => [_createVNode(_component_el_icon, null, {
                      default: _withCtx(() => [_createVNode(_unref(InfoFilled))]),
                      _: 1
                    })]),
                    _: 1
                  })])]),
                  default: _withCtx(() => [_createVNode(_component_el_input, {
                    modelValue: system.value['mj_action_power'],
                    "onUpdate:modelValue": _cache[28] || (_cache[28] = $event => system.value['mj_action_power'] = $event),
                    modelModifiers: {
                      number: true
                    },
                    placeholder: ""
                  }, null, 8, ["modelValue"])]),
                  _: 1
                }), _createVNode(_component_el_form_item, {
                  label: "Stable-Diffusion算力",
                  prop: "sd_power"
                }, {
                  default: _withCtx(() => [_createVNode(_component_el_input, {
                    modelValue: system.value['sd_power'],
                    "onUpdate:modelValue": _cache[29] || (_cache[29] = $event => system.value['sd_power'] = $event),
                    modelModifiers: {
                      number: true
                    },
                    placeholder: "使用Stable-Diffusion画一张图消耗算力"
                  }, null, 8, ["modelValue"])]),
                  _: 1
                }), _createVNode(_component_el_form_item, {
                  label: "DALL-E-3算力",
                  prop: "dall_power"
                }, {
                  label: _withCtx(() => [_createElementVNode("div", _hoisted_15, [_cache[58] || (_cache[58] = _createTextVNode(" MJ操作算力 ")), _createVNode(_component_el_tooltip, {
                    effect: "dark",
                    content: "主要用户函数调用 DALL-E-3 进行绘画",
                    "raw-content": "",
                    placement: "right"
                  }, {
                    default: _withCtx(() => [_createVNode(_component_el_icon, null, {
                      default: _withCtx(() => [_createVNode(_unref(InfoFilled))]),
                      _: 1
                    })]),
                    _: 1
                  })])]),
                  default: _withCtx(() => [_createVNode(_component_el_input, {
                    modelValue: system.value['dall_power'],
                    "onUpdate:modelValue": _cache[30] || (_cache[30] = $event => system.value['dall_power'] = $event),
                    modelModifiers: {
                      number: true
                    },
                    placeholder: "使用DALL-E-3画一张图消耗算力"
                  }, null, 8, ["modelValue"])]),
                  _: 1
                }), _createVNode(_component_el_form_item, {
                  label: "Suno 算力",
                  prop: "suno_power"
                }, {
                  default: _withCtx(() => [_createVNode(_component_el_input, {
                    modelValue: system.value['suno_power'],
                    "onUpdate:modelValue": _cache[31] || (_cache[31] = $event => system.value['suno_power'] = $event),
                    modelModifiers: {
                      number: true
                    },
                    placeholder: "使用 Suno 生成一首音乐消耗算力"
                  }, null, 8, ["modelValue"])]),
                  _: 1
                }), _createVNode(_component_el_form_item, {
                  label: "Luma 算力",
                  prop: "luma_power"
                }, {
                  default: _withCtx(() => [_createVNode(_component_el_input, {
                    modelValue: system.value['luma_power'],
                    "onUpdate:modelValue": _cache[32] || (_cache[32] = $event => system.value['luma_power'] = $event),
                    modelModifiers: {
                      number: true
                    },
                    placeholder: "使用 Luma 生成一段视频消耗算力"
                  }, null, 8, ["modelValue"])]),
                  _: 1
                }), _createVNode(_component_el_form_item, null, {
                  label: _withCtx(() => [_createElementVNode("div", _hoisted_16, [_cache[59] || (_cache[59] = _createTextVNode(" 高级语音算力 ")), _createVNode(_component_el_tooltip, {
                    effect: "dark",
                    content: "使用一次 OpenAI 高级语音对话消耗的算力",
                    "raw-content": "",
                    placement: "right"
                  }, {
                    default: _withCtx(() => [_createVNode(_component_el_icon, null, {
                      default: _withCtx(() => [_createVNode(_unref(InfoFilled))]),
                      _: 1
                    })]),
                    _: 1
                  })])]),
                  default: _withCtx(() => [_createVNode(_component_el_input, {
                    modelValue: system.value['advance_voice_power'],
                    "onUpdate:modelValue": _cache[33] || (_cache[33] = $event => system.value['advance_voice_power'] = $event),
                    modelModifiers: {
                      number: true
                    },
                    placeholder: ""
                  }, null, 8, ["modelValue"])]),
                  _: 1
                }), _createVNode(_component_el_form_item, null, {
                  label: _withCtx(() => [_createElementVNode("div", _hoisted_17, [_cache[60] || (_cache[60] = _createTextVNode(" 提示词算力 ")), _createVNode(_component_el_tooltip, {
                    effect: "dark",
                    content: "生成AI绘图提示词，歌词，视频描述消耗的算力",
                    "raw-content": "",
                    placement: "right"
                  }, {
                    default: _withCtx(() => [_createVNode(_component_el_icon, null, {
                      default: _withCtx(() => [_createVNode(_unref(InfoFilled))]),
                      _: 1
                    })]),
                    _: 1
                  })])]),
                  default: _withCtx(() => [_createVNode(_component_el_input, {
                    modelValue: system.value['prompt_power'],
                    "onUpdate:modelValue": _cache[34] || (_cache[34] = $event => system.value['prompt_power'] = $event),
                    modelModifiers: {
                      number: true
                    },
                    placeholder: ""
                  }, null, 8, ["modelValue"])]),
                  _: 1
                })]),
                _: 1
              })]),
              _: 1
            }), _createElementVNode("div", _hoisted_18, [_createVNode(_component_el_form_item, null, {
              default: _withCtx(() => [_createVNode(_component_el_button, {
                type: "primary",
                onClick: _cache[35] || (_cache[35] = $event => save('system'))
              }, {
                default: _withCtx(() => _cache[61] || (_cache[61] = [_createTextVNode("保存")])),
                _: 1
              })]),
              _: 1
            })])]),
            _: 1
          }, 8, ["model", "rules"])])]),
          _: 1
        }), _createVNode(_component_el_tab_pane, {
          label: "公告配置",
          name: "notice"
        }, {
          default: _withCtx(() => [_createVNode(_unref(MdEditor), {
            class: "mgb20",
            modelValue: notice.value,
            "onUpdate:modelValue": _cache[36] || (_cache[36] = $event => notice.value = $event),
            theme: _unref(store).theme,
            onOnUploadImg: onUploadImg
          }, null, 8, ["modelValue", "theme"]), _createVNode(_component_el_form_item, null, {
            default: _withCtx(() => [_createElementVNode("div", _hoisted_19, [_createVNode(_component_el_button, {
              type: "primary",
              onClick: _cache[37] || (_cache[37] = $event => save('notice'))
            }, {
              default: _withCtx(() => _cache[62] || (_cache[62] = [_createTextVNode("保存")])),
              _: 1
            })])]),
            _: 1
          })]),
          _: 1
        }), _createVNode(_component_el_tab_pane, {
          label: "思维导图",
          name: "mark_map"
        }, {
          default: _withCtx(() => [_createVNode(_unref(MdEditor), {
            class: "mgb20",
            theme: _unref(store).theme,
            modelValue: system.value['mark_map_text'],
            "onUpdate:modelValue": _cache[38] || (_cache[38] = $event => system.value['mark_map_text'] = $event),
            onOnUploadImg: onUploadImg
          }, null, 8, ["theme", "modelValue"]), _createVNode(_component_el_form_item, null, {
            default: _withCtx(() => [_createElementVNode("div", _hoisted_20, [_createVNode(_component_el_button, {
              type: "primary",
              onClick: _cache[39] || (_cache[39] = $event => save('system'))
            }, {
              default: _withCtx(() => _cache[63] || (_cache[63] = [_createTextVNode("保存")])),
              _: 1
            })])]),
            _: 1
          })]),
          _: 1
        }), _createVNode(_component_el_tab_pane, {
          label: "菜单配置",
          name: "menu"
        }, {
          default: _withCtx(() => [_createVNode(Menu)]),
          _: 1
        }), _createVNode(_component_el_tab_pane, {
          label: "授权激活",
          name: "license"
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_21, [license.value.is_active ? (_openBlock(), _createBlock(_component_el_descriptions, {
            key: 0,
            class: "margin-top",
            title: "已授权信息",
            column: 1,
            border: ""
          }, {
            default: _withCtx(() => [_createVNode(_component_el_descriptions_item, null, {
              label: _withCtx(() => _cache[64] || (_cache[64] = [_createElementVNode("div", {
                class: "cell-item"
              }, "License Key", -1)])),
              default: _withCtx(() => [_createTextVNode(" " + _toDisplayString(license.value.key), 1)]),
              _: 1
            }), _createVNode(_component_el_descriptions_item, null, {
              label: _withCtx(() => _cache[65] || (_cache[65] = [_createElementVNode("div", {
                class: "cell-item"
              }, "机器码", -1)])),
              default: _withCtx(() => [_createTextVNode(" " + _toDisplayString(license.value.machine_id), 1)]),
              _: 1
            }), _createVNode(_component_el_descriptions_item, null, {
              label: _withCtx(() => _cache[66] || (_cache[66] = [_createElementVNode("div", {
                class: "cell-item"
              }, "到期时间", -1)])),
              default: _withCtx(() => [_createTextVNode(" " + _toDisplayString(_unref(dateFormat)(license.value.expired_at)), 1)]),
              _: 1
            }), _createVNode(_component_el_descriptions_item, null, {
              label: _withCtx(() => _cache[67] || (_cache[67] = [_createElementVNode("div", {
                class: "cell-item"
              }, "用户人数", -1)])),
              default: _withCtx(() => [_createTextVNode(" " + _toDisplayString(license.value.configs?.user_num), 1)]),
              _: 1
            }), _createVNode(_component_el_descriptions_item, null, {
              label: _withCtx(() => _cache[68] || (_cache[68] = [_createElementVNode("div", {
                class: "cell-item"
              }, "去版权", -1)])),
              default: _withCtx(() => [license.value.configs?.de_copy ? (_openBlock(), _createBlock(_component_el_icon, {
                key: 0,
                class: "selected"
              }, {
                default: _withCtx(() => [_createVNode(_unref(Select))]),
                _: 1
              })) : (_openBlock(), _createBlock(_component_el_icon, {
                key: 1,
                class: "closed"
              }, {
                default: _withCtx(() => [_createVNode(_unref(CloseBold))]),
                _: 1
              })), _cache[69] || (_cache[69] = _createElementVNode("span", {
                class: "text"
              }, "去版权之后前端页面将不会显示版权信息和源码地址", -1))]),
              _: 1
            })]),
            _: 1
          })) : _createCommentVNode("", true), _cache[71] || (_cache[71] = _createElementVNode("h3", null, "激活后可获得以下权限：", -1)), _cache[72] || (_cache[72] = _createElementVNode("ol", {
            class: "active-info"
          }, [_createElementVNode("li", null, "1、使用任意第三方中转 API KEY，而不用局限于 ZHIPAI 推荐的白名单列表"), _createElementVNode("li", null, "2、可以在相关页面去除 ZHIPAI-AI 的版权信息，或者修改为自己的版权信息")], -1)), _createVNode(_component_el_form, {
            model: system.value,
            "label-width": "150px",
            "label-position": "right"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_form_item, {
              label: "许可授权码",
              prop: "license"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_input, {
                modelValue: licenseKey.value,
                "onUpdate:modelValue": _cache[40] || (_cache[40] = $event => licenseKey.value = $event)
              }, null, 8, ["modelValue"])]),
              _: 1
            }), _createVNode(_component_el_form_item, null, {
              default: _withCtx(() => [_createVNode(_component_el_button, {
                type: "primary",
                onClick: active
              }, {
                default: _withCtx(() => _cache[70] || (_cache[70] = [_createTextVNode("立即激活")])),
                _: 1
              })]),
              _: 1
            })]),
            _: 1
          }, 8, ["model"])])]),
          _: 1
        }), _createVNode(_component_el_tab_pane, {
          label: "修复数据",
          name: "fixData"
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_22, [_cache[74] || (_cache[74] = _createElementVNode("p", {
            class: "text"
          }, " 有些版本升级的时候更新了数据库的结构，比如字段名字改了，需要把之前的字段的值转移到其他字段，这些无法通过简单的 SQL 语句可以实现的，需要手动写程序修正数据。 ", -1)), _createElementVNode("div", _hoisted_23, [_createVNode(_component_el_button, {
            type: "primary",
            onClick: fixData
          }, {
            default: _withCtx(() => _cache[73] || (_cache[73] = [_createTextVNode("立即修复")])),
            _: 1
          })])])]),
          _: 1
        })]),
        _: 1
      }, 8, ["modelValue"])])), [[_directive_loading, loading.value]]);
    };
  }
};